import Axios from 'util/service/index';
import {
    SET_API_ENDPOINTS,
    SET_CANTON_DETAIL_SEARCH_VALUE,
    SET_ENTRIES,
    SET_SEARCH_LOCATION,
    SET_SEARCH_RESULTS,
    SET_SEARCH_RESULTS_LOADING_STATE,
} from '../../mutation-types';

/**
 * Remove all search results from the store
 * @param {any} commit - The vuex commit method
 */
export function clearSearchResults({ commit }) {
    commit(SET_SEARCH_RESULTS_LOADING_STATE, { isLoadingSearchResults: false });
    commit(SET_SEARCH_RESULTS, { searchResults: [] });
}

/**
 * Remove the search location
 * @param {any} commit - The vuex commit method
 */
export function clearSearchLocation({ commit }) {
    commit(SET_SEARCH_LOCATION, { bounds: null, location: null });
}

/**
 * Get an entry detail data set from the API
 * @param {any} state - The vuex module state
 * @param {any} payload - The request payload
 * @return {Promise}
 */
export function loadEntry({ state }, payload) {
    const url = state.api.loadEntryDetails;

    return new Promise((resolve, reject) => {
        Axios.request({ method: 'post', url, data: payload }).then(
            ({ data }) => resolve(data),
            error => reject(error),
        );
    });
}

export function loadEntries({ commit, state }) {
    const url = state.api.loadMapEntries;

    return new Promise((resolve, reject) => {
        Axios.request({ method: 'post', url }).then(
            ({ data }) => {
                commit(SET_ENTRIES, data);
                resolve(data);
            },
            error => {
                reject(error);
            },
        );
    });
}

/**
 * Request a list of search results from the API
 * @param {any} commit - The vuex commit method
 * @param {any} state - The vuex module state
 * @param {IGeoLocationBounds} bounds - The search location's bounds
 * @param {string} canton - A conditional string indicating a canton query
 * @param {string} query - The original query string for the search
 * @param {IGeoLocation} center - The search location's center
 * @return {Promise}
 */
export function loadSearchResults({ commit, state }, { bounds, canton, center, query }) {
    const url = state.api.loadSearchResults;
    const payload = { bounds, canton, center, query };
    commit(SET_SEARCH_RESULTS_LOADING_STATE, { isLoadingSearchResults: true });
    commit(SET_SEARCH_RESULTS, { searchResults: [] });

    return new Promise((resolve, reject) => {
        Axios.request({ method: 'post', url, data: payload }).then(
            ({ data }) => {
                commit(SET_SEARCH_RESULTS_LOADING_STATE, { isLoadingSearchResults: false });
                commit(SET_SEARCH_RESULTS, { searchResults: data.searchResults });
                resolve(data);
            },
            error => {
                commit(SET_SEARCH_RESULTS_LOADING_STATE, { isLoadingSearchResults: false });
                reject(error);
            },
        );
    });
}

/**
 * Add api endpoints for the module
 * @param {any} commit - The vuex commit method
 * @param {any} api - The api object containing the endpoint descriptors
 */
export function setApiEndpoints({ commit }, { api }) {
    commit(SET_API_ENDPOINTS, { api });
}

/**
 * Add api endpoints for the module
 * @param {any} commit - The vuex commit method
 * @param {any} value - The initial search value
 */
export function setCantonDetailSearchValue({ commit }, { value }) {
    commit(SET_CANTON_DETAIL_SEARCH_VALUE, { value });
}

/**
 * Set a resolved geo location to the application's search
 * @param {any} commit - The vuex commit method
 * @param {IGeoLocation} center - The search location's center
 * @param {string} query - The original search query
 * @param {IGeoLocationBounds} bounds - The search location's bounds
 */
export function setSearchLocation({ commit }, { bounds, center, query }) {
    commit(SET_SEARCH_LOCATION, { bounds, center, query });
}
